import React from 'react';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { CourseContainer } from '../../UserRoutes/UserHomepage/UserHomeStyles.styles';
import EmployeesTab from '../CompanyTabs/Employees/EmployeesTab.component';
import { useParams } from 'react-router-dom';
import Auth from '../../Helpers/auth';
import CompanyHomeDataProvider from '../../Utils/Companies/CompanyHomeDataProvider';
const CompanyEmployeesPage = () => {
  const { id } = useParams();
  const { data } = Auth.getProfile();

  return (
    <AuthCheckManager>
      <HelmetHelper
        title="Company Managers & Employees"
        description="List of the company managers and employees"
      />
      <CourseContainer>
        <BreadCrumbs
          one="Company Dashboard"
          oneLink={`/company`}
          two="Managers & Employees"
        />
        <CompanyHomeDataProvider id={data?.id}>
          {(company) => (
            <>
              <h2>Managers & Employees</h2>
              <EmployeesTab company={company} companyId={id} />
            </>
          )}
        </CompanyHomeDataProvider>
      </CourseContainer>
    </AuthCheckManager>
  );
};

export default CompanyEmployeesPage;
